/*
 * Copyright (c) 2017 OCLC, Inc. All Rights Reserved.
 *
 * OCLC proprietary information: the enclosed materials contain proprietary information of OCLC Online Computer
 * Library Center, Inc. and shall not be disclosed in whole or in any part to any third party or used by any person
 * for any purpose, without written consent of OCLC, Inc.  Duplication of any portion of these materials shall include
 * this notice.
 */

const defaultOptions = {
  credentials: 'same-origin',
  headers: {
    'Accept': 'application/json; charset=utf-8',
    'Content-Type': 'application/json'
  }
}

const canonicalize = (url) => {
  if (url.indexOf('http') !== 0) {
    if (url.indexOf('/') === 0) {
      url = process.env.PUBLIC_URL + url;
    } else {
      url = process.env.PUBLIC_URL + '/' + url;
    }
  }
  return url;
};

/**
 * Creates a small wrapper around the standard Fetch API to apply common configuration across all fetch calls. There
 * is no explicit support for this in the standard fetch API.
 */
export const api = (url, options) => {
  let opts = Object.assign({}, defaultOptions, options);
  url = canonicalize(url);
  return fetch(url, opts);
}



// WEBPACK FOOTER //
// ./src/api/api.js